import { ISocialIcon } from './ISocialIcon';
import React from 'react';

const VkSvg = ({
  width = '16',
  height = '10',
  viewBox = '0 0 16 10',
  fill = 'none',
}: ISocialIcon): React.ReactElement => {
  return (
    <svg width={width} height={height} viewBox={viewBox} fill={fill} xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.2771 5.35219C13.0184 5.02551 13.0925 4.88017 13.2771 4.58816C13.2805 4.58483 15.4159 1.63406 15.6359 0.633355L15.6372 0.632689C15.7465 0.268009 15.6372 0 15.1085 0H13.3591C12.9138 0 12.7084 0.230008 12.5984 0.48735C12.5984 0.48735 11.7077 2.61942 10.4477 4.00147C10.041 4.40082 9.85301 4.52882 9.631 4.52882C9.52166 4.52882 9.35166 4.40082 9.35166 4.03614V0.632689C9.35166 0.19534 9.22699 0 8.85831 0H6.10754C5.8282 0 5.6622 0.204007 5.6622 0.394014C5.6622 0.808695 6.29222 0.904031 6.35755 2.07074V4.60216C6.35755 5.15685 6.25688 5.25885 6.03354 5.25885C5.43885 5.25885 3.99547 3.11811 3.14011 0.668023C2.96744 0.192673 2.79876 0.00066669 2.35008 0.00066669H0.600021C0.10067 0.00066669 0 0.230675 0 0.488017C0 0.942699 0.594687 3.20344 2.76543 6.19021C4.21215 8.22895 6.24955 9.33366 8.10295 9.33366C9.21699 9.33366 9.35299 9.08832 9.35299 8.6663C9.35299 6.71823 9.25232 6.53423 9.81034 6.53423C10.069 6.53423 10.5144 6.66223 11.5544 7.6456C12.7431 8.81164 12.9384 9.33366 13.6038 9.33366H15.3532C15.8519 9.33366 16.1046 9.08831 15.9592 8.6043C15.6265 7.58626 13.3785 5.49219 13.2771 5.35219Z"
        fill="white"
      />
    </svg>
  );
};

export default VkSvg;
